<header class="section-header">
  <h2>روندهای روزانه امضای الکتریکی</h2>
  <span><bdi>{{ context.dates?.length || 0 }}</bdi> روز دارای رکورد</span>
</header>
<div class="electrical-chart-grid">
  <section class="electrical-chart" *ngFor="let chart of charts">
    <h3>{{ chart.title }}</h3>
    <app-chart [context]="chart"></app-chart>
  </section>
</div>
<p class="chart-note">روزهای فاقد دادهٔ معتبر الکتریکی به‌صورت گسست در نمودار نمایش داده می‌شوند.</p>
